import getFieldMeta from '../../utils/getFieldMeta';

export function applyValidationsToFields(manager, field) {
  if (!field) return;

  if (
    (field.type === 'field' || field.type === 'upload') &&
    field.originalKey
  ) {
    const originalValidations = manager
      .getValidationRules(field.originalKey)
      ?.map(validation => {
        if (validation && validation.enumRef !== undefined) {
          const { enumRef, ...rest } = validation;
          return rest;
        }
        return validation;
      });

    manager.updateComponentValidations(
      field.type,
      field,
      field.properties,
      originalValidations?.[0] || {},
      true
    );
  }

  if (Array.isArray(field.properties)) {
    field.properties.forEach(child => applyValidationsToFields(manager, child));
  }
}

export function applyEnumsToFields(manager, field) {
  if (!field) return;

  if (field.type === 'field' && field.originalKey) {
    const originalField = getFieldMeta({
      fields: manager.fields,
      key: 'key',
      value: field.originalKey,
    });

    if (originalField && originalField.enumRef) {
      const originalEnumOptions = manager.getEnum(
        originalField.enumRef,
        originalField.parentEnum
      );

      manager.enumsManager.updateEnums(
        {
          options: originalEnumOptions,
          fields: manager.fields,
          componentId: field.id,
          parentEnum: undefined,
        },
        manager.validations
      );
    }
  }

  if (Array.isArray(field.properties)) {
    field.properties.forEach(child => applyEnumsToFields(manager, child));
  }
}
